import React, { useState } from 'react';
import {
  Warehouse, Store, AlertTriangle, CheckCircle2, X, Truck,
  TrendingUp, Package,
} from 'lucide-react';

const BRANCHES = [
  { id: 1, name: 'Kelapa Gading', city: 'Jakarta Utara', stock: 92, par: 100, lowItems: 2 },
  { id: 2, name: 'Kemang', city: 'Jakarta Selatan', stock: 76, par: 100, lowItems: 8 },
  { id: 3, name: 'BSD City', city: 'Tangerang', stock: 98, par: 100, lowItems: 1 },
  { id: 4, name: 'Bekasi', city: 'Bekasi', stock: 62, par: 100, lowItems: 12 },
  { id: 5, name: 'Depok', city: 'Depok', stock: 100, par: 100, lowItems: 0 },
  { id: 6, name: 'Bogor', city: 'Bogor', stock: 84, par: 100, lowItems: 4 },
  { id: 7, name: 'Cikarang', city: 'Bekasi', stock: 78, par: 100, lowItems: 6 },
  { id: 8, name: 'Tangerang', city: 'Tangerang', stock: 71, par: 100, lowItems: 10 },
  { id: 9, name: 'Cibinong', city: 'Bogor', stock: 88, par: 100, lowItems: 3 },
  { id: 10, name: 'Jonggol', city: 'Bogor', stock: 65, par: 100, lowItems: 9 },
  { id: 11, name: 'Cilincing', city: 'Jakarta Utara', stock: 79, par: 100, lowItems: 5 },
  { id: 12, name: 'Grogol', city: 'Jakarta Barat', stock: 73, par: 100, lowItems: 7 },
  { id: 13, name: 'Lebak Bulus', city: 'Jakarta Selatan', stock: 91, par: 100, lowItems: 2 },
  { id: 14, name: 'Serpong', city: 'Tangerang Selatan', stock: 82, par: 100, lowItems: 4 },
];

const WAREHOUSE_STOCK = {
  totalUnits: 18640,
  capacity: 20000,
  skusTracked: 29,
  lowStockAlerts: 16,
};

const HISTORICAL_FULFILLMENT = [
  { id: 1, branch: 'Kelapa Gading', units: 42, requested: '2026-09-04 08:00', delivered: '2026-09-04 10:30', status: 'Delivered', daysOld: 0 },
  { id: 2, branch: 'Kemang', units: 58, requested: '2026-09-04 07:45', delivered: '2026-09-04 10:12', status: 'Delivered', daysOld: 0 },
  { id: 3, branch: 'BSD City', units: 18, requested: '2026-09-04 08:15', delivered: '2026-09-04 10:52', status: 'Delivered', daysOld: 0 },
  { id: 4, branch: 'Bekasi', units: 94, requested: '2026-09-03 09:00', delivered: '2026-09-03 14:25', status: 'Delivered', daysOld: 1 },
  { id: 5, branch: 'Bogor', units: 56, requested: '2026-09-03 08:30', delivered: '2026-09-03 11:45', status: 'Delivered', daysOld: 1 },
  { id: 6, branch: 'Cikarang', units: 72, requested: '2026-09-03 07:00', delivered: '2026-09-03 10:15', status: 'Delivered', daysOld: 1 },
  { id: 7, branch: 'Tangerang', units: 86, requested: '2026-09-02 08:00', delivered: '2026-09-02 12:30', status: 'Delivered', daysOld: 2 },
  { id: 8, branch: 'Cibinong', units: 48, requested: '2026-09-02 09:15', delivered: '2026-09-02 11:00', status: 'Delivered', daysOld: 2 },
  { id: 9, branch: 'Jonggol', units: 104, requested: '2026-09-02 07:45', delivered: '2026-09-02 13:20', status: 'Delivered', daysOld: 2 },
  { id: 10, branch: 'Cilincing', units: 64, requested: '2026-09-01 08:00', delivered: '2026-09-01 10:45', status: 'Delivered', daysOld: 3 },
];

const FULFILLMENT_METRICS = {
  totalShipmentsLastWeek: 82,
  onTimeDelivery: 98.5,
  avgDeliveryTime: '2.8h',
  totalUnitsDispatched: 7840,
  stockoutsPrevented: 47,
};

const getStatusColor = (stock, par) => {
  const percent = (stock / par) * 100;
  if (percent >= 90) return '#10b981';
  if (percent >= 70) return '#f59e0b';
  return '#ef4444';
};

const BranchNode = ({ branch, index, totalBranches, isSelected, onClick }) => {
  const angle = (index / totalBranches) * Math.PI * 2 - Math.PI / 2;
  const radius = 280;
  const x = 400 + radius * Math.cos(angle);
  const y = 400 + radius * Math.sin(angle);
  const statusColor = getStatusColor(branch.stock, branch.par);
  const stockPercent = (branch.stock / branch.par) * 100;

  return (
    <g key={branch.id} onClick={onClick} style={{ cursor: 'pointer' }}>
      <line x1="400" y1="400" x2={x} y2={y} stroke={statusColor} strokeWidth="1" opacity="0.3" />
      <circle
        cx={x}
        cy={y}
        r="45"
        fill={isSelected ? statusColor : 'rgba(255,255,255,0.05)'}
        stroke={statusColor}
        strokeWidth={isSelected ? '3' : '2'}
        opacity={isSelected ? '1' : '0.6'}
      />
      <circle cx={x} cy={y} r="25" fill="#050506" stroke={statusColor} strokeWidth="1" />
      <text
        x={x}
        y={y}
        textAnchor="middle"
        dy="0.3em"
        fontSize="14"
        fontWeight="bold"
        fill={statusColor}
      >
        {stockPercent.toFixed(0)}%
      </text>
      <text
        x={x}
        y={y - 65}
        textAnchor="middle"
        fontSize="12"
        fontWeight="600"
        fill="white"
      >
        {branch.name}
      </text>
      {branch.lowItems > 0 && (
        <circle cx={x + 35} cy={y - 35} r="16" fill="#ef4444" />
      )}
      {branch.lowItems > 0 && (
        <text
          x={x + 35}
          y={y - 32}
          textAnchor="middle"
          dy="0.3em"
          fontSize="11"
          fontWeight="bold"
          fill="white"
        >
          {branch.lowItems}
        </text>
      )}
    </g>
  );
};

const RecommendationCard = ({ branch, onApprove, onDismiss }) => {
  const recommendedUnits = Math.max(0, branch.par - branch.stock);
  const urgency = branch.lowItems > 5 ? 'Critical' : branch.lowItems > 2 ? 'High' : 'Standard';
  const urgencyColor = branch.lowItems > 5 ? '#ef4444' : branch.lowItems > 2 ? '#f59e0b' : '#10b981';

  return (
    <div className="border border-white/10 rounded-lg bg-white/[0.02] p-6 max-w-md">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="h-sans text-[20px] font-medium">{branch.name}</h3>
          <p className="text-white/60 text-[13px]">{branch.city}</p>
        </div>
        <button
          onClick={onDismiss}
          className="text-white/40 hover:text-white/60 transition-colors"
        >
          <X size={20} />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-white/5 rounded p-3">
          <p className="text-white/60 text-[11px] mb-1">Current Stock</p>
          <p className="h-sans text-[20px] font-medium">{branch.stock} units</p>
        </div>
        <div className="bg-white/5 rounded p-3">
          <p className="text-white/60 text-[11px] mb-1">Par Level</p>
          <p className="h-sans text-[20px] font-medium">{branch.par} units</p>
        </div>
      </div>

      <div className="mb-4">
        <div className="w-full bg-white/5 rounded-full h-2 mb-2">
          <div
            className="h-full rounded-full transition-all"
            style={{
              width: `${(branch.stock / branch.par) * 100}%`,
              background: getStatusColor(branch.stock, branch.par),
            }}
          />
        </div>
        <p className="text-white/60 text-[11px]">
          {((branch.stock / branch.par) * 100).toFixed(0)}% of par
        </p>
      </div>

      <div className="bg-orange-500/10 border border-orange-500/30 rounded p-3 mb-4">
        <div className="flex items-start gap-2">
          <AlertTriangle size={16} className="text-orange-400 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-white text-[13px] font-medium mb-1">Urgent Replenishment</p>
            <p className="text-white/60 text-[12px]">
              {branch.lowItems} SKUs below par level. Last shipment 4h ago.
            </p>
          </div>
        </div>
      </div>

      <div className="border border-[#10b981]/30 bg-[#10b981]/5 rounded p-3 mb-4">
        <p className="text-[10px] uppercase text-white/50 font-medium mb-2">AI Recommendation</p>
        <div className="flex items-baseline justify-between mb-2">
          <p className="h-sans text-[24px] font-medium text-[#10b981]">
            Send {recommendedUnits} units
          </p>
          <span
            className="px-2 py-1 rounded text-[11px] font-medium"
            style={{ background: `${urgencyColor}22`, color: urgencyColor, border: `1px solid ${urgencyColor}55` }}
          >
            {urgency}
          </span>
        </div>
        <p className="text-white/60 text-[12px]">
          Calculated to reach par level by EOD. Truck available immediately.
        </p>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => onApprove(branch.id, recommendedUnits)}
          className="flex-1 bg-[#10b981] text-black font-medium py-2 rounded-lg hover:bg-[#0da76f] transition-colors flex items-center justify-center gap-2"
        >
          <CheckCircle2 size={16} />
          Approve & Send
        </button>
        <button
          onClick={onDismiss}
          className="flex-1 border border-white/10 text-white/80 font-medium py-2 rounded-lg hover:border-white/20 transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export function WarehouseAgentView() {
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [approvedShipments, setApprovedShipments] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleApprove = (branchId, units) => {
    const branch = BRANCHES.find(b => b.id === branchId);
    setApprovedShipments([
      ...approvedShipments,
      {
        id: Date.now(),
        branchId,
        branchName: branch.name,
        units,
        timestamp: new Date().toLocaleTimeString(),
      },
    ]);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
    setSelectedBranch(null);
  };

  const selected = selectedBranch ? BRANCHES.find(b => b.id === selectedBranch) : null;
  const totalBelowPar = BRANCHES.filter(b => b.stock < b.par).length;
  const averageStockLevel = Math.round(
    BRANCHES.reduce((sum, b) => sum + (b.stock / b.par) * 100, 0) / BRANCHES.length
  );

  return (
    <div className="max-w-[1600px] mx-auto">
      {/* KPI Grid */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-12">
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">WAREHOUSE STOCK</p>
          <p className="h-sans text-[24px] font-medium mb-1">{WAREHOUSE_STOCK.totalUnits.toLocaleString()}</p>
          <p className="text-white/50 text-[12px]">of {WAREHOUSE_STOCK.capacity.toLocaleString()} capacity</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">BRANCHES AT RISK</p>
          <p className="h-sans text-[24px] font-medium text-orange-400">{totalBelowPar}</p>
          <p className="text-white/50 text-[12px]">of 14 branches below par</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">AVG STOCK LEVEL</p>
          <p className="h-sans text-[24px] font-medium">{averageStockLevel}%</p>
          <p className="text-white/50 text-[12px]">of par across branches</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">PENDING SHIPMENTS</p>
          <p className="h-sans text-[24px] font-medium text-[#10b981]">{approvedShipments.length}</p>
          <p className="text-white/50 text-[12px]">approved & ready to dispatch</p>
        </div>
        <div className="border border-[#10b981]/30 bg-[#10b981]/5 rounded-lg p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">CAPACITY USED</p>
          <p className="h-sans text-[24px] font-medium text-[#10b981]">
            {Math.round((WAREHOUSE_STOCK.totalUnits / WAREHOUSE_STOCK.capacity) * 100)}%
          </p>
          <p className="text-white/50 text-[12px]">healthy utilization</p>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
        <div className="lg:col-span-2 border border-white/10 rounded-lg bg-white/[0.02] p-6 overflow-hidden">
          <div className="flex items-center gap-2 mb-6">
            <Warehouse size={20} className="text-[#10b981]" />
            <div>
              <h2 className="h-sans text-[20px] font-medium">Warehouse Network</h2>
              <p className="text-white/60 text-[13px]">Click a branch for agent recommendation</p>
            </div>
          </div>

          <svg width="100%" height="820" viewBox="0 0 800 800" style={{ background: 'rgba(255,255,255,0.01)', borderRadius: '8px' }}>
            <defs>
              <filter id="glow">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            <circle cx="400" cy="400" r="60" fill="rgba(16, 185, 129, 0.1)" stroke="#10b981" strokeWidth="2" filter="url(#glow)" />
            <rect x="375" y="375" width="50" height="50" fill="#10b981" rx="4" />
            <text x="400" y="408" textAnchor="middle" dy="0.3em" fontSize="24" fill="#050506" fontWeight="bold">
              📦
            </text>
            <text x="400" y="475" textAnchor="middle" fontSize="13" fontWeight="600" fill="white">
              Central Warehouse
            </text>
            <text x="400" y="492" textAnchor="middle" fontSize="11" fill="white/60">
              Cikarang
            </text>

            {BRANCHES.map((branch, idx) => (
              <BranchNode
                key={branch.id}
                branch={branch}
                index={idx}
                totalBranches={BRANCHES.length}
                isSelected={selectedBranch === branch.id}
                onClick={() => setSelectedBranch(branch.id)}
              />
            ))}
          </svg>

          <div className="mt-4 p-3 bg-white/5 rounded text-[12px] text-white/60">
            <p>🟢 Healthy (&gt;90%) • 🟡 Low stock (70-89%) • 🔴 Critical (&lt;70%)</p>
          </div>
        </div>

        <div className="lg:col-span-1">
          {selected ? (
            <RecommendationCard
              branch={selected}
              onApprove={handleApprove}
              onDismiss={() => setSelectedBranch(null)}
            />
          ) : (
            <div className="border border-white/10 rounded-lg bg-white/[0.02] p-6 h-full flex flex-col items-center justify-center text-center">
              <Store size={40} className="text-white/30 mb-3 mx-auto" />
              <p className="text-white/60 text-[13px]">
                Select a branch from the map to see AI recommendations for inventory transfer.
              </p>
              <p className="text-white/40 text-[12px] mt-2">
                {totalBelowPar} branches need attention.
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Pending Shipments */}
      {approvedShipments.length > 0 && (
        <div className="border border-[#10b981]/30 rounded-lg bg-[#10b981]/5 overflow-hidden mb-12">
          <div className="p-6 border-b border-[#10b981]/20">
            <div className="flex items-center gap-2 mb-1">
              <Truck size={18} className="text-[#10b981]" />
              <h2 className="h-sans text-[20px] font-medium">Approved Shipments</h2>
            </div>
            <p className="text-white/60 text-[13px]">Ready for dispatch</p>
          </div>
          <div className="divide-y divide-[#10b981]/20">
            {approvedShipments.map((shipment) => (
              <div key={shipment.id} className="p-4 flex items-center justify-between hover:bg-[#10b981]/10 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#10b981]" />
                  <div>
                    <p className="font-medium text-[13px]">{shipment.branchName}</p>
                    <p className="text-white/60 text-[12px]">{shipment.units} units</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-white/60 text-[12px]">{shipment.timestamp}</p>
                  <span className="inline-block px-2 py-1 rounded text-[10px] bg-[#10b981]/20 text-[#10b981] font-medium mt-1">
                    Ready to dispatch
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Success notification */}
      {showSuccess && (
        <div className="fixed bottom-6 right-6 bg-[#10b981] text-black px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-pulse">
          <CheckCircle2 size={20} />
          <p className="font-medium">Shipment approved and queued for dispatch</p>
        </div>
      )}

      {/* Fulfillment Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-12">
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">SHIPMENTS (7D)</p>
          <p className="h-sans text-[24px] font-medium">{FULFILLMENT_METRICS.totalShipmentsLastWeek}</p>
          <p className="text-white/50 text-[12px]">dispatched successfully</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">ON-TIME DELIVERY</p>
          <p className="h-sans text-[24px] font-medium text-[#10b981]">{FULFILLMENT_METRICS.onTimeDelivery}%</p>
          <p className="text-white/50 text-[12px]">last 7 days</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">AVG DELIVERY TIME</p>
          <p className="h-sans text-[24px] font-medium">{FULFILLMENT_METRICS.avgDeliveryTime}</p>
          <p className="text-white/50 text-[12px]">warehouse to branch</p>
        </div>
        <div className="border border-white/10 rounded-lg bg-white/[0.02] p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">UNITS SENT (7D)</p>
          <p className="h-sans text-[24px] font-medium">{FULFILLMENT_METRICS.totalUnitsDispatched.toLocaleString()}</p>
          <p className="text-white/50 text-[12px]">across all branches</p>
        </div>
        <div className="border border-[#10b981]/30 bg-[#10b981]/5 rounded-lg p-4">
          <p className="text-white/60 text-[11px] font-medium mb-2">STOCKOUTS PREVENTED</p>
          <p className="h-sans text-[24px] font-medium text-[#10b981]">{FULFILLMENT_METRICS.stockoutsPrevented}</p>
          <p className="text-white/50 text-[12px]">this month</p>
        </div>
      </div>

      {/* Historical Fulfillment */}
      <div className="border border-white/10 rounded-lg bg-white/[0.02] overflow-hidden mb-12">
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center gap-2 mb-1">
            <TrendingUp size={18} className="text-[#10b981]" />
            <h2 className="h-sans text-[20px] font-medium">Recent Fulfillment History</h2>
          </div>
          <p className="text-white/60 text-[13px]">Last 10 shipments delivered to branches</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/5">
                <th className="px-4 py-3 text-left text-[12px] font-medium text-white/50 uppercase tracking-wider">Branch</th>
                <th className="px-4 py-3 text-center text-[12px] font-medium text-white/50 uppercase tracking-wider">Units</th>
                <th className="px-4 py-3 text-center text-[12px] font-medium text-white/50 uppercase tracking-wider">Requested</th>
                <th className="px-4 py-3 text-center text-[12px] font-medium text-white/50 uppercase tracking-wider">Delivered</th>
                <th className="px-4 py-3 text-center text-[12px] font-medium text-white/50 uppercase tracking-wider">Cycle Time</th>
                <th className="px-4 py-3 text-right text-[12px] font-medium text-white/50 uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody>
              {HISTORICAL_FULFILLMENT.map((fulfillment) => {
                const reqTime = new Date(fulfillment.requested);
                const delTime = new Date(fulfillment.delivered);
                const cycleMinutes = Math.round((delTime - reqTime) / 60000);
                const cycleHours = (cycleMinutes / 60).toFixed(1);

                return (
                  <tr key={fulfillment.id} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                    <td className="px-4 py-3 text-[13px] font-medium">{fulfillment.branch}</td>
                    <td className="px-4 py-3 text-[13px] text-center text-white/60">{fulfillment.units}</td>
                    <td className="px-4 py-3 text-[13px] text-center text-white/60">
                      {reqTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td className="px-4 py-3 text-[13px] text-center text-white/60">
                      {delTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td className="px-4 py-3 text-[13px] text-center">
                      <span className="inline-block px-2 py-1 rounded text-[11px] bg-[#10b981]/20 text-[#10b981] font-medium">
                        {cycleHours}h
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="inline-block px-2 py-1 rounded text-[11px] font-medium bg-[#10b981]/20 text-[#10b981]">
                        ✓ {fulfillment.status}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* All branches overview */}
      <div className="border border-white/10 rounded-lg bg-white/[0.02] overflow-hidden">
        <div className="p-6 border-b border-white/10">
          <div className="flex items-center gap-2 mb-1">
            <Package size={18} className="text-white/40" />
            <h2 className="h-sans text-[20px] font-medium">All Branches - Stock Health</h2>
          </div>
          <p className="text-white/60 text-[13px]">Real-time inventory levels vs par</p>
        </div>
        <div className="divide-y divide-white/5">
          {BRANCHES.map((branch) => {
            const statusColor = getStatusColor(branch.stock, branch.par);
            const stockPercent = (branch.stock / branch.par) * 100;
            return (
              <div
                key={branch.id}
                className="p-4 hover:bg-white/[0.02] transition-colors cursor-pointer"
                onClick={() => setSelectedBranch(branch.id)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 flex-1">
                    <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: statusColor }} />
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-[13px]">{branch.name}</p>
                      <p className="text-white/40 text-[12px]">{branch.city}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-6">
                    <div className="text-right">
                      <p className="text-white/60 text-[12px] mb-1">Stock</p>
                      <p className="h-sans text-[16px] font-medium">{stockPercent.toFixed(0)}%</p>
                    </div>
                    <div className="w-32 bg-white/5 rounded-full h-1.5">
                      <div
                        className="h-full rounded-full transition-all"
                        style={{ width: `${stockPercent}%`, background: statusColor }}
                      />
                    </div>
                    {branch.lowItems > 0 && (
                      <div className="text-right flex-shrink-0">
                        <span className="inline-block px-2 py-1 rounded text-[11px] font-medium bg-orange-500/20 text-orange-400">
                          {branch.lowItems} low
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
